import { Flex, Input } from 'antd';
import { Filter, Form } from 'components';
import type { Paths } from 'type-fest';
import { FilterControlButtons } from 'components/form/FilterControlButtons';
import {
  DEFAULT_FILTER,
  type CompatibleModulesFilterShape,
  useCompatibleModulesFilterWithPagination,
} from '../hooks/useMeterModelsFilterWithPagination';
import { OutputTechnologiesSelect } from '../../../../../../../../../components/form/select/OutputTechnologySelect';

export const MeterModelCompatibleModulesFilter = () => {
  const [form] = Form.useForm<CompatibleModulesFilterShape>();

  const { filter, setFilterState, resetFilterState, setPaginationState } = useCompatibleModulesFilterWithPagination();

  const handleReset = () => {
    form.setFieldsValue(DEFAULT_FILTER);

    resetFilterState();
    setPaginationState({
      current: 1,
    });
  };

  return (
    <Filter form={form} initialValues={filter} onFinish={setFilterState}>
      <Form.Item label="Search" name={'search' satisfies Paths<CompatibleModulesFilterShape>}>
        <Input allowClear placeholder="Search by name..." />
      </Form.Item>

      <Form.Item label="Technology" name={'technologies' satisfies Paths<CompatibleModulesFilterShape>}>
        <OutputTechnologiesSelect />
      </Form.Item>

      <Flex align="end" flex={2} justify="space-between">
        <FilterControlButtons onClickReset={handleReset} />
      </Flex>
    </Filter>
  );
};
